import {ErrorDto} from "../models/dtos/error.dto";

export class Errors {
  
  public static readonly errorGenericTitle: string = 'Hay aksi!';
  public static readonly errorGenericText: string = 'Beklenmeyen bir hata oluştu.';
  
  public static readonly errorMessagePaymentInsufficientFunds: string = 'payment_insufficient_funds';
  public static readonly errorMessagePaymentCountExceeded: string = 'payment_count_exceeded';
  public static readonly errorMessagePaymentGeneralError: string = 'payment_general_error';
  
  public static readonly paymentError: ErrorDto = {
    path: '/',
    status: 500,
    message: Errors.errorMessagePaymentGeneralError,
  }
  
  public static isAuthErrorStatus(error: any): boolean {
    return error.response?.status === 401 || error.response?.status === 403;
  }
  
  public static isAuthError(error: ErrorDto): boolean {
    return error.status === 401 || error.status === 403;
  }
  
  public static isDeviceError(error: ErrorDto): boolean {
    return error.status === 410;
  }
  
  public static isContactUsError(error: ErrorDto): boolean {
    return error.path.includes('/misc/contact');
  }
  
  public static isPaymentLogError(error: ErrorDto): boolean {
    return error.path.includes('/users/payment/request');
  }
  
  public static isPaymentError(error: ErrorDto): boolean {
    return (
      error.message === this.errorMessagePaymentInsufficientFunds ||
      error.message === this.errorMessagePaymentCountExceeded ||
      error.message === this.errorMessagePaymentGeneralError
    );
  }
}
